// Where Vikas has been published, interviewed or featured. Adding one is a single entry here: it appears
// in the strip on the home and founders pages, and in the Person JSON-LD (`subjectOf`) that tells search
// engines and LLMs this person is written about in named publications.
//
// `kind` is what the appearance actually is, and it matters: "Guest post" is a byline he wrote, "Interview"
// is a publication writing about him. Claiming the wrong one is the fastest way to lose the credibility the
// strip exists to build.
//
// `logo` is optional. Drop a file in public/press/ (SVG or transparent PNG, roughly 200x40, dark on light)
// and name it here; with no file the outlet renders as a muted wordmark, which is the honest default rather
// than a hotlink to someone else's asset.
export const VIKAS_PRESS = [
  {
    outlet: 'e27',
    kind: 'Guest post',
    title: 'Market access is the new moat: Why international expansion is no longer a size game',
    url: 'https://e27.co/market-access-is-the-new-moat-why-international-expansion-is-no-longer-a-size-game-20260801/',
    date: '2026-08-01',
    logo: '',
  },
  {
    outlet: 'Finance Middle East',
    kind: 'Interview',
    title: 'Founders in focus: After burning out and starting over, Vikas Goel made EsportsXO investor-ready in Abu Dhabi',
    url: 'https://www.financemiddleeast.com/start-up-and-entrepreneurship/founders-in-focus-after-burning-out-and-starting-over-vikas-foel-made-esportsxo-investor-ready-in-abu-dhabi/',
    date: '2025-06-13',
    logo: '',
  },
  {
    outlet: 'GIBS Business School',
    kind: 'Talk',
    title: 'Intent, AI & the Business of Gaming: Vikas Goel on Building EXO | IRE Talk',
    url: 'https://www.youtube.com/watch?v=hBW-EAEGjws',
    date: '',
    logo: '',
  },
  {
    outlet: 'Indian Startup News',
    kind: 'Video',
    title: 'Startup’s 100 Stories: EsportsXO on distribution and discovery in Indian gaming',
    url: 'https://www.facebook.com/watch/?v=1747708948972812',
    date: '',
    logo: '',
  },
];

// Articles written ABOUT him, for schema.org `subjectOf`. A guest post he authored is not "about" him,
// so it is deliberately excluded rather than padding the list.
export const VIKAS_SUBJECT_OF = VIKAS_PRESS
  .filter((p) => p.kind !== 'Guest post')
  .map((p) => ({
    '@type': ['Video', 'Talk'].includes(p.kind) ? 'VideoObject' : 'NewsArticle',
    name: p.title,
    url: p.url,
    publisher: { '@type': 'Organization', name: p.outlet },
    ...(p.date ? { datePublished: p.date } : {}),
  }));
